import { defineMessage } from 'services/localization';

export const messages = {
    addDefaultReviewer: defineMessage('add_the_default_reviewer'),
    addDefaultReviewerDescription: defineMessage('a_default_reviewer_is_a_viewer_specified_for_it'),
};
